"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiterPerSecondPerSquareMeter = exports.CubicFeetPerMinutePerSquareFeet = exports.CubicMeterPerSecondPerSquareMeter = void 0;
var UnitDivide = require("../unit-divide");
var volume_flow_1 = require("./volume-flow");
var area_1 = require("./area");
// VolumeFlowPerArea
exports.CubicMeterPerSecondPerSquareMeter = UnitDivide.volumeFlowByArea("CubicMeterPerSecondPerSquareMeter", volume_flow_1.CubicMeterPerSecond, area_1.SquareMeter);
exports.CubicFeetPerMinutePerSquareFeet = UnitDivide.volumeFlowByArea("CubicFeetPerMinutePerSquareFeet", volume_flow_1.CubicFeetPerMinute, area_1.SquareFeet);
exports.LiterPerSecondPerSquareMeter = UnitDivide.volumeFlowByArea("LiterPerSecondPerSquareMeter", volume_flow_1.LiterPerSecond, area_1.SquareMeter);
//# sourceMappingURL=volume-flow-per-area.js.map